import { ca } from '@cian/analytics';

import { EEntityType } from '../../types/filters';

export function trackCategoryClick(type: EEntityType | null) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'ListingFavorites',
    label: type === EEntityType.Newbuilding ? 'newbuilding' : 'offer',
    page: {
      extra: {
        favorite_pagetype: type === EEntityType.Newbuilding ? 'newbuilding' : 'offer',
      },
    },
  });
}

export const trackSavedSearchClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'ListingFavorites',
    label: 'savedsearch',
    page: {
      extra: {
        favorite_pagetype: 'savedsearch',
      },
    },
  });
};
